import { ChangeEvent, useContext, useEffect, useState } from "react";
import { Socket } from "socket.io-client";
import IVendorModel from "@models/IVendorModel";
import IErrorDTO from "@models/DTO/IErrorDTO";
import INotification from "@models/INotification";
import OwLabel from "@components/shared/OwLabel/OwLabel";
import SupplierContext from "@contexts/SupplierContext";
import UserContext from "@contexts/UserContext";
import VendorContext from "@contexts/VendorContext";
import EndpointsEnum from "@models/EndpointsEnum";
import IGetVendorsDTO from "@models/DTO/IGetVendorsDTO";
import IOnGetVendorsDTO from "@models/DTO/IOnGetVendorsDTO";
import Typeahead from "@components/shared/Typeahead/Typeahead";
import ICatalog from "@models/ICatalog";
import IPrice_Group from "@models/IPrice_Group";
import INewAddress from "@models/INewAddress";
import OwButton from "@components/shared/OwButton/OwButton";
import { DashboardItemEntryPanel } from "../DashboardItemEntryPanel/DashboardItemEntryPanel";
import UIService from "@services/UIService";
import IOrder_ItemUI from "@models/IOrder_ItemUI";
import IDashboardEntryItemUI from "@models/IDashboardEntryItemUI";
import OrderEntryService from "@services/OrderEntryService";
import IOrder from "@models/IOrder";
import OrderStatesEnum from "@models/OrderStatesEnum";
import ICatalog_Item from "@models/ICatalog_Item";
import { DashboardItemEntryTotalsPanel } from "../DashboardItemEntryTotalsPanel/DashboardItemEntryTotalsPanel";
import ICreateOrderWithItemsDTO from "@models/DTO/ICreateOrderWithItemsDTO";
import OrderSourceEnum from "@models/OrderSourceEnum";
import INewOrder_Item from "@models/INewOrder_Item";
import NotificationLevelEnum from "@models/NotificationLevelEnum";
import NotificationPositionEnum from "@models/NotificationPositionEnum";
import SocketService from "@services/SocketService";
import { useNavigate } from "react-router-dom";
import IReconcileOrderWithItemsResultsDTO from "@models/DTO/IReconcileOrderWithItemsResultsDTO";
import IUiSocketSetup from "@models/IUiSocketSetup";
import IDashboardEntryWidget from "@models/IDashboardEntryWidget";
import DashboardEntryComponentEnum from "@models/DashboardEntryComponentEnum";
import { DashboardEntryShipToWidget } from "./DashboardEntryShipToWidget/DashboardEntryShipToWidget";
import { DashboardEntryDetailsWidget } from "./DashboardEntryDetailsWidget/DashboardEntryDetailsWidget";
import IPanasonicOrderDetails from "@models/IPanasonicOrderDetails";
import SupplierService from "@services/SupplierService";
import * as _ from "lodash-es";
import SupplierGuidEnum from "@models/SupplierGuidEnum";
import { DashboardEntryPanasonicResellerWidget } from "@components/custom/DashboardEntryPanasonicResellerWidget/DashboardEntryPanasonicResellerWidget";
import { DashboardEntryPanasonicEndUserWidget } from "@components/custom/DashboardEntryPanasonicEndUserWidget/DashboardEntryPanasonicEndUserWidget";
import { DashboardEntryPanasonicDeliveryInfoWidget } from "@components/custom/DashboardEntryPanasonicDeliveryInfoWidget/DashboardEntryPanasonicDeliveryInfoWidget";
import { DashboardEntryPanasonicProjectInfoWidget } from "@components/custom/DashboardEntryPanasonicProjectInfoWidget/DashboardEntryPanasonicProjectInfoWidget";
import OwTitle from "@components/shared/OwTitle/OwTitle";
import ky from "ky";
import { isNil, startCase } from "lodash-es";
import INewOrder_ItemWithOptions from "@models/INewOrder_ItemWithOptions";

type Props = {
    isOnline: boolean;
    socket: Socket;
    setActivityIndicator: (activityOn: boolean, isInitialLoad?: boolean) => void;
    notifyFn: (data: IErrorDTO | null, _notification?: INotification, isFormatted?: boolean) => void;
};

export interface OrderDetails {
    poNumber: string;
    isLocalPickup: boolean;
    isLocalDelivery: boolean;
    notes: string;
    internalNotes: string;
}

export const DashboardOrderEntry = (props: Props) => {
    const supplierModel = useContext(SupplierContext);
    const userModel = useContext(UserContext);
    const vendorModel = useContext(VendorContext);

    const history = useNavigate();

    const getDashboardEntryWidgets = (): IDashboardEntryWidget[] => {
        if (supplierModel.dashboard_entry_config?.widgets) {
            return supplierModel.dashboard_entry_config.widgets;
        } else {
            return [
                {
                    title: "ship_to",
                    component: DashboardEntryComponentEnum.SHIP_TO,
                },
                {
                    title: "details",
                    component: DashboardEntryComponentEnum.DETAILS,
                },
            ];
        }
    };

    const [foundAccounts, setFoundAccounts] = useState<IVendorModel[]>([]);
    const [selectedAccount, setSelectedAccount] = useState<IVendorModel | undefined>(userModel.isSupplierUser ? undefined : vendorModel);
    const [catalogOptions, setCatalogOptions] = useState<ICatalog[]>([]);
    const [selectedCatalog, setSelectedCatalog] = useState<ICatalog | undefined>(
        userModel.isSupplierUser ? undefined : vendorModel.Catalog
    );
    const [selectedPriceGroup, setSelectedPriceGroup] = useState<IPrice_Group | undefined>(
        userModel.isSupplierUser ? undefined : vendorModel.Price_Group
    );
    const [availablePriceGroups, setAvailablePriceGroups] = useState<IPrice_Group[]>([]);
    const [hasSingleCatalogLock, setHasSingleCatalogLock] = useState(false);
    const [hasSinglePriceGroupLock, setHasSinglePriceGroupLock] = useState(false);
    const [isCreateActive, setIsCreateActive] = useState(false);
    const [poNumber, setPoNumber] = useState("");
    const [shipTo, setShipTo] = useState<INewAddress>(userModel.isSupplierUser ? {} : vendorModel.Ship_To);
    const [orderStarted, setOrderStarted] = useState(!userModel.isSupplierUser);
    const [submitActive, setSubmitActive] = useState(false);
    const [dashboardItems, setDashboardItems] = useState<IDashboardEntryItemUI[]>([]);
    const [clearSelectVendorTypeahead, setClearSelectVendorTypeahead] = useState(false);
    const [createSuccess, setCreateSuccess] = useState(false);
    const [orderName, setOrderName] = useState("");

    const [orderDetails, setOrderDetails] = useState<OrderDetails>({
        poNumber: "",
        isLocalPickup: false,
        isLocalDelivery: false,
        notes: "",
        internalNotes: "",
    });
    const [panasonicDetails, setPanasonicDetails] = useState<IPanasonicOrderDetails>({} as IPanasonicOrderDetails);
    const [shipping, setShipping] = useState(0);
    const [submitErrors, setSubmitErrors] = useState<IReconcileOrderWithItemsResultsDTO>();
    const [widgets, setWidgets] = useState<IDashboardEntryWidget[]>(getDashboardEntryWidgets());
    const [sectionEditModeTracker, setSectionEditModeTracker] = useState<{ [key: string]: boolean }>({});
    const [noOpenEditMode, setNoOpenEditMode] = useState(true);

    const onGetAccounts = (data: IOnGetVendorsDTO) => {
        const _foundAccounts = data.supplierVendorTokens.map((tokenData) => tokenData.Vendor!);

        setFoundAccounts(_foundAccounts);
    };

    const sockets: IUiSocketSetup[] = [{ endpoint: EndpointsEnum.VendorsOnGetVendors, fn: onGetAccounts }];

    useEffect(() => {
        for (const socket of sockets) {
            props.socket.on(socket.endpoint, socket.fn);
        }

        return () => {
            for (const socket of sockets) {
                props.socket.removeListener(socket.endpoint, socket.fn);
            }
        };
    }, []);

    const getAccounts = (name: string) => {
        // TODO make work with browser offline mode.
        const encodedName = encodeURIComponent(name);

        const payload: IGetVendorsDTO = {
            userGuid: userModel.guid,
            userToken: userModel.token,
            supplierGuid: supplierModel.guid,
            queryString: `name=${encodedName}`,
            limit: 20,
        };

        props.socket.emit(EndpointsEnum.VendorsGetVendors, payload);
    };

    const selectAccount = (account: IVendorModel) => {
        setSelectedAccount(account);
        // getCatalogs();

        if (account.Catalog && !account.Price_Groups_Map) {
            setSelectedCatalog(account.Catalog);
            setHasSingleCatalogLock(true);

            if (account.Price_Group) {
                setSelectedPriceGroup(account.Price_Group);
                setHasSinglePriceGroupLock(true);
            }
        }

        if (!account.Catalog) {
            if (supplierModel.Default_Catalog && supplierModel.Default_Price_Group) {
                setSelectedCatalog(supplierModel.Default_Catalog);
                setSelectedPriceGroup(supplierModel.Default_Price_Group);
                setHasSinglePriceGroupLock(true);
            }
        }

        if (account.Ship_To) {
            setShipTo(account.Ship_To);
        }
    };

    const toggleStart = () => {
        setOrderStarted(!orderStarted);
    };

    const submitOrder = () => {
        const payload: ICreateOrderWithItemsDTO = {
            supplierGuid: supplierModel.guid,
            userToken: userModel.token,
            userGuid: userModel.guid,
            vendorGuid: selectedAccount!.guid,
            shipTo,
            catalogGuid: selectedCatalog!.guid,
            priceGroupGuid: selectedPriceGroup!.guid,
            source: OrderSourceEnum.ORDERWERKS,
            order: {
                order_state_id: OrderStatesEnum.PRELIMINARY,
                supplier_id: supplierModel.id,
                po_no: orderDetails.poNumber,
                is_local_delivery: orderDetails.isLocalDelivery,
                is_local_pickup: orderDetails.isLocalPickup,
                note: orderDetails.notes,
                internal_note: orderDetails.internalNotes,
                shipping,
            },
            orderItems: dashboardItems.map((item, index) => {
                return {
                    item_no: index + 1,
                    catalog_item_id: item.Catalog_Item.id,
                    qty: item.qty,
                    list_price_frozen: item.manual_price,
                    is_manual_price: !isNil(item.manual_price),
                    description: item.description,
                    msrp: item.msrp,
                    itemOptionValues: item.Item_Options?.map((option) => {
                        return {
                            item_option_id: option.item_option_id,
                            value: option.value,
                        };
                    }),
                } as INewOrder_ItemWithOptions;
            }),
            remainInPreliminary: !!supplierModel.dashboard_order_entry_remain_prelim,
        };

        if (supplierModel.guid === SupplierGuidEnum.PANASONIC_CA) {
            payload.panasonicOrderDetails = panasonicDetails;
        }

        const apiUrl = SocketService.getApiEndpointURl();

        setSubmitActive(true);
        setSubmitErrors(undefined);

        const url = `${apiUrl}/v1/orderWithItems`;

        ky.post<{ order: IOrder }>(url, {
            json: payload,
            headers: {
                userGuid: userModel.guid,
                userToken: userModel.token,
                supplierGuid: supplierModel.guid,
                vendorGuid: selectedAccount!.guid,
            },
        })
            .then(async (res) => {
                const notification: INotification = {
                    title: "successfully_submitted_order",
                    level: NotificationLevelEnum.success,
                    position: NotificationPositionEnum.bc,
                };

                props.notifyFn(null, notification);

                const data = await res.json();

                if (data.order) {
                    setOrderName(data.order.name || "");
                    setSubmitActive(false);

                    history(`/dashboard/ordering/success/${data.order.name}/${data.order.guid}`);
                } else {
                    console.error("No valid order provided: ", data);
                }
            })
            .catch(async (err) => {
                if (err.response) {
                    const errResp = await err.response.json();

                    let message = errResp.errMessage || errResp.message || "An error occurred";

                    if (errResp.noAccountAccess) {
                        message = "no_account_access";
                    } else if (errResp.inactiveAccount) {
                        message = "inactive_account";
                    } else if (errResp.errors?.length) {
                        message = "order_has_item_errors";
                    }

                    const notification: INotification = {
                        title: "error_submitting_order",
                        message,
                        level: NotificationLevelEnum.error,
                        position: NotificationPositionEnum.bc,
                    };

                    props.notifyFn(null, notification);

                    setSubmitActive(false);
                    setSubmitErrors(errResp);
                } else {
                    const notification: INotification = {
                        title: "error_submitting_order",
                        message: "An error occurred",
                        level: NotificationLevelEnum.error,
                        position: NotificationPositionEnum.bc,
                    };

                    props.notifyFn(null, notification);

                    setSubmitActive(false);
                }
            });
    };

    const cancelOrder = () => {
        setOrderStarted(false);
        setDashboardItems([]);
        setSelectedAccount(undefined);
        setFoundAccounts([]);
        setSelectedCatalog(undefined);
        setSelectedPriceGroup(undefined);
        setShipTo({});
        setClearSelectVendorTypeahead(true);
    };

    const addItem = (item: IDashboardEntryItemUI) => {
        const items = [...dashboardItems];
        item.uiGuid = UIService.getGuid();
        items.push(item);

        setDashboardItems(items);
    };

    const removeItem = (item: IDashboardEntryItemUI) => {
        const items = [...dashboardItems].filter((_item) => _item.uiGuid !== item.uiGuid);

        setDashboardItems(items);
    };

    const updateItem = (item: IDashboardEntryItemUI) => {
        const items = [...dashboardItems];

        items.forEach((_item, index) => {
            if (_item.uiGuid === item.uiGuid) {
                console.log("Found Item: ", item);
                items[index] = item;
            }
        });

        setDashboardItems(items);
    };

    /**
     * Get the Price for the Order Item based on if it's the stored, manual or catalog item price
     *
     * @param orderItem
     */
    const getPricingValue = (item: ICatalog_Item): number => {
        const orderItem = { Catalog_Item: item } as IOrder_ItemUI;

        // console.log("order: ", this.state.order);
        const orderSetup = {
            order_state_id: OrderStatesEnum.PRELIMINARY,
            Price_Group: selectedPriceGroup,
        } as IOrder;

        return OrderEntryService.getPricingValue(orderItem, supplierModel, orderSetup);
    };

    const setShippingValue = (value: number) => {
        setShipping(value);
    };

    const clearSelectedVendor = () => {
        setSelectedAccount(undefined);
        setClearSelectVendorTypeahead(false);
    };

    const updateAddress = (e: ChangeEvent<any>) => {
        const value = e.target.value;
        const name = e.target.name;

        const _shipTo: INewAddress = { ...shipTo };
        // @ts-expect-error
        _shipTo[name] = value;

        setShipTo(_shipTo);
    };

    const updateOrderDetails = (details: OrderDetails) => {
        setOrderDetails(details);
    };

    const updatePanasonicDetails = (details: IPanasonicOrderDetails) => {
        setPanasonicDetails({ ...panasonicDetails, ...details });
    };

    useEffect(() => {
        const _noOpenEditMode = Object.values(sectionEditModeTracker).every((value) => !value);

        setNoOpenEditMode(_noOpenEditMode);
    }, [sectionEditModeTracker]);

    const trackSectionInEditMode = (section: string, editMode: boolean) => {
        const tracker = { ...sectionEditModeTracker };

        tracker[section] = editMode;

        setSectionEditModeTracker(tracker);
    };

    const getNotSavedMessage = () => {
        let message = `${startCase(SupplierService.updateStringWithOrderNameOverride("order", supplierModel))} Is Not
        Saved Until Submitted.`;

        if (supplierModel.guid === SupplierGuidEnum.PANASONIC_CA) {
            message = `Deal Registration Is Not
            Saved Until Submitted.`;
        }

        return message;
    };

    return (
        <div className={"DashboardOrderEntry mt-2"}>
            <div className={"row mb-2"}>
                <div className={"col"}>
                    {supplierModel.guid === SupplierGuidEnum.PANASONIC_CA ? <OwTitle title={"new_deal_registration"} tag={"h4"} /> : null}
                </div>
            </div>
            <div className={"row"}>
                <div className={"col-2"}>
                    <div>
                        <OwLabel title={"vendor"} supplierModel={supplierModel} isSupplierVendorOverride={true} isBold={true} />
                    </div>
                    <div>
                        <Typeahead
                            isSelectableFn={() => true}
                            typeaheadApiFn={getAccounts}
                            typeaheadItems={foundAccounts}
                            titleProp={"name"}
                            subTitleProp={"customer_internal_id"}
                            scrollableList={true}
                            maxResults={100}
                            selectedItem={selectedAccount}
                            selectedItemTitleProp={"name"}
                            selectedItemFn={selectAccount}
                            disabled={orderStarted}
                            clearTypeaheadCallback={clearSelectedVendor}
                            clearTypeahead={clearSelectVendorTypeahead}
                        />
                    </div>
                    <div>
                        {selectedAccount?.email ? (
                            <>
                                <OwLabel title={"email"} isBold={true} postText={":"} className={"me-2"} />
                                {selectedAccount.email}
                            </>
                        ) : null}
                    </div>
                </div>

                <div className={"col d-flex align-items-center"}>
                    {orderStarted ? (
                        <div className={"ms-auto text-end"}>
                            <div className={"d-flex align-items-center justify-content-end"}>
                                <div className={"d-flex flex-column"}>
                                    <div className={"text-danger me-3"}>
                                        <i className={"fas fa-stop"} /> {getNotSavedMessage()}
                                    </div>
                                    {!noOpenEditMode ? (
                                        <div className={"text-danger me-3"}>
                                            <i className={"fas fa-stop"} /> Save All Sections To Submit.
                                        </div>
                                    ) : null}
                                </div>
                                <div>
                                    <OwButton
                                        title={"submit"}
                                        fn={submitOrder}
                                        className={"btn-warning"}
                                        disableOnActive={true}
                                        disabled={dashboardItems.length === 0 || !noOpenEditMode}
                                        active={submitActive}
                                    />
                                </div>
                            </div>
                            {userModel.isSupplierUser ? (
                                <div className={"mt-3"}>
                                    <OwButton
                                        title={"cancel"}
                                        fn={cancelOrder}
                                        className={"btn-danger"}
                                        disableOnActive={true}
                                        active={submitActive}
                                    />
                                </div>
                            ) : null}
                        </div>
                    ) : null}
                </div>
            </div>

            <div className={"row mt-4 card-deck"}>
                {widgets.map((widget, index) => {
                    switch (widget.component) {
                        case DashboardEntryComponentEnum.SHIP_TO:
                            return <DashboardEntryShipToWidget key={index} shipTo={shipTo} updateAddress={updateAddress} />;
                        case DashboardEntryComponentEnum.DETAILS:
                            return orderStarted ? (
                                <DashboardEntryDetailsWidget key={index} updateOrderDetails={updateOrderDetails} />
                            ) : null;
                        case DashboardEntryComponentEnum.PANASONIC_RESELLER:
                            return orderStarted ? (
                                <DashboardEntryPanasonicResellerWidget
                                    key={index}
                                    updateDetails={updatePanasonicDetails}
                                    sectionInEditMode={trackSectionInEditMode}
                                />
                            ) : null;
                        case DashboardEntryComponentEnum.PANASONIC_END_USER:
                            return orderStarted ? (
                                <DashboardEntryPanasonicEndUserWidget
                                    key={index}
                                    updateDetails={updatePanasonicDetails}
                                    sectionInEditMode={trackSectionInEditMode}
                                />
                            ) : null;
                        case DashboardEntryComponentEnum.PANASONIC_DELIVERY_INFO:
                            return orderStarted ? (
                                <DashboardEntryPanasonicDeliveryInfoWidget
                                    key={index}
                                    updateDetails={updatePanasonicDetails}
                                    sectionInEditMode={trackSectionInEditMode}
                                />
                            ) : null;
                        case DashboardEntryComponentEnum.PANASONIC_PROJECT_INFO:
                            return orderStarted ? (
                                <DashboardEntryPanasonicProjectInfoWidget key={index} updateDetails={updatePanasonicDetails} />
                            ) : null;
                        default:
                            return null;
                    }
                })}
                {/*<DashboardEntryShipToWidget shipTo={shipTo} updateAddress={updateAddress}/>*/}
                {/*{orderStarted ? (*/}
                {/*    <DashboardEntryDetailsWidget updateOrderDetails={updateOrderDetails}/>*/}
                {/*) : null}*/}
            </div>

            {orderStarted ? (
                <div className={"mt-4"}>
                    <DashboardItemEntryPanel
                        priceGroup={selectedPriceGroup!}
                        catalog={selectedCatalog!}
                        dashboardEntryItems={dashboardItems}
                        addItem={addItem}
                        removeItem={removeItem}
                        updateItem={updateItem}
                        getPricingValue={getPricingValue}
                        submitErrors={submitErrors}
                    />
                    <DashboardItemEntryTotalsPanel
                        catalog={selectedCatalog!}
                        priceGroup={selectedPriceGroup!}
                        dashboardEntryItems={dashboardItems}
                        getPricingValue={getPricingValue}
                        setShippingValue={setShippingValue}
                    />
                </div>
            ) : (
                <div className={"mt-2"}>
                    <OwButton title={"start"} fn={toggleStart} className={"btn-warning"} disabled={!selectedAccount} />
                </div>
            )}
        </div>
    );
};
